module.exports = __webpack_public_path__ + "img/brandstory_img2.df0d0c88.png";